import { from, Observable, race, throwError, timer } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

export class CardinalConnectivityTester {
  test(url: string, timeout: number): Observable<void> {
    const fetchRequest$ = from(
      fetch(url, {
        method: "HEAD",
        mode: "no-cors",
      }),
    ).pipe(
      map(() => void 0),
      catchError((error) => {
        let errorType = "CONNECTIVITY_ERROR";
        let errorMessage = "Failed to connect to Cardinal Commerce";

        if (error.name === "TypeError") {
          errorType = "CONNECTIVITY_BLOCKED";
          errorMessage =
            "Cardinal connection blocked (possible CSP or CORS issue)";
        } else if (
          error.name === "NetworkError" ||
          error.message?.includes("network")
        ) {
          errorType = "NETWORK_ERROR";
          errorMessage = "Network error during connectivity test";
        }

        const connectError = new Error(errorMessage);
        (connectError as any).errorType = errorType;
        (connectError as any).originalError = error;
        (connectError as any).originalErrorName = error.name;
        return throwError(() => connectError);
      }),
    );

    const timeout$ = timer(timeout).pipe(
      switchMap(() => {
        const timeoutError = new Error(
          `Connectivity test timeout after ${timeout}ms`,
        );
        (timeoutError as any).errorType = "CONNECTIVITY_TIMEOUT";
        return throwError(() => timeoutError);
      }),
    );

    return race(fetchRequest$, timeout$);
  }
}
